"use client";

import Link from "next/link";
import { ROUTES, SITE } from "@/content/site";
import { useDimFavicon } from "@/lib/favicon";
import "@/app/not-found.css";

type Props = {
  code: string;
  title: string;
  lead: string;
  /** Error digest from Next (server logs correlate on it). */
  reference?: string;
  onRetry?: () => void;
  retryLabel?: string;
};

/**
 * Branded fallback shared by error.tsx / global-error.tsx / offline — same
 * visual language as the 404 page, never a blank screen. The tab icon turns
 * grey while it is shown.
 */
export function ErrorState({
  code,
  title,
  lead,
  reference,
  onRetry,
  retryLabel = "تلاش دوباره",
}: Props) {
  useDimFavicon("error");

  return (
    <section className="cf404" aria-labelledby="cf404-title">
      <div className="cf404-frame">
        <div className="cf404-code cf404-code--word" aria-hidden>
          {code}
        </div>
        <h1 id="cf404-title" className="cf404-title">
          {title}
        </h1>
        <p className="cf404-lead">{lead}</p>

        <nav className="cf404-actions" aria-label="پیوندهای پیشنهادی">
          {onRetry ? (
            <button type="button" className="cf404-btn cf404-btn--primary" onClick={onRetry}>
              {retryLabel}
            </button>
          ) : null}
          <Link className={onRetry ? "cf404-btn" : "cf404-btn cf404-btn--primary"} href={ROUTES.home}>
            بازگشت به خانه
          </Link>
          <Link className="cf404-btn" href={ROUTES.products}>
            محصولات
          </Link>
          <a className="cf404-btn" href={`tel:${SITE.phone}`} dir="ltr">
            {SITE.phoneDisplay}
          </a>
        </nav>

        {reference ? (
          <footer className="cf404-foot">
            <p>
              <span className="cf404-foot-label">کد پیگیری</span>
              <code className="cf404-ray">{reference}</code>
            </p>
          </footer>
        ) : null}
      </div>
    </section>
  );
}
